
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.349 8.945c.203-.435.294-.932.238-1.465-.133-1.212-1.078-2.243-2.282-2.446a2.807 2.807 0 00-3.261 3.259c.21 1.205 1.231 2.151 2.442 2.284a2.75 2.75 0 001.463-.238L10.601 12l-1.652 1.654a2.747 2.747 0 00-1.463-.238c-1.211.133-2.239 1.079-2.442 2.284a2.802 2.802 0 003.254 3.259c1.204-.21 2.149-1.233 2.282-2.446a2.763 2.763 0 00-.238-1.464l1.659-1.647 5.312 5.319c.623.623 1.687.182 1.687-.701v-.007c0-.259-.105-.512-.287-.701l-8.364-8.367zm-2.548.252a1.4 1.4 0 11.001-2.801 1.4 1.4 0 01-.001 2.801zm0 8.41a1.4 1.4 0 01-1.4-1.402 1.4 1.4 0 112.8 0 1.4 1.4 0 01-1.4 1.402zm4.2-5.256a.347.347 0 01-.35-.351c0-.196.154-.35.35-.35.196 0 .35.154.35.35a.347.347 0 01-.35.351zm5.312-7.072l-4.612 4.619 1.4 1.401 4.612-4.618A.99.99 0 0019 5.98v-.007c0-.876-1.064-1.317-1.687-.694z","fill-rule":"nonzero"}})])
          )
        }
      }
    